import { createAction, props } from "@ngrx/store";

export const createNewStandingAuthClicked = createAction(
    '[Create Standing Authorization - Confirmation Page] Create another standing authorization clicked',
    props<{ accountId: string }>()
);

export const returnStandingAuthClicked = createAction(
    '[Create Standing Authorization - Confirmation Page] Create another standing authorization clicked',
    props<{ accountId: string }>()
);